import XLSX from 'xlsx'
import PropTypes from 'prop-types';
import { Button} from '@mui/material';
function Botones({data}) {
    const handleClick = () => {
     // Crear un libro de Excel y convertir el array en una hoja de cálculo
  const libro = XLSX.utils.book_new();
  const hoja = XLSX.utils.json_to_sheet(data);
  XLSX.utils.book_append_sheet(libro, hoja, 'Reportes');
  // Generar un archivo de Excel y descargarlo
  XLSX.writeFile(libro, 'reportes.xlsx');}

    return(
    <div>
      
  <Button variant="contained" onClick={handleClick} color="success">Descargar Excel</Button>
    </div>
    );
}
Botones.propTypes = {
    data: PropTypes.array,
}
export default Botones